import React, { useState, useEffect } from "react";
import axios from "axios";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MdDelete } from "react-icons/md";

const Certificates = () => {

  const [positions, setPositions] = useState({});
  const [images, setImages] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  // 🔹 Handle multiple image select
  const imgHandler = (e) => {
    setImages([...e.target.files]);
  };

  // 🔹 Upload images
  const btnHandler = async (e) => {
    e.preventDefault();

    if (images.length === 0) {
      return toast.error("Please select images");
    }

    try {

      const formData = new FormData();

      images.forEach((img) => {
        formData.append("image", img);
      });

      const res = await axios.post(
        `http://localhost:3232/api/v1/certificates`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      toast.success(res.data.message);

      setImages([]);

      getCertificates();

    } catch (err) {

      console.log(err);

      toast.error("Upload failed");
    }
  };

  // 🔹 Get list
  const getCertificates = async () => {
    try {

      setLoading(true);

      const res = await axios.get(
        `http://localhost:3232/api/v1/certificates`
      );

      const certificateData = res.data.data;

      setData(certificateData);

      const posObj = {};

      certificateData.forEach((item) => {
        posObj[item.id] = item.position ?? "";
      });

      setPositions(posObj);

      setLoading(false);

    } catch (err) {

      console.log(err);

      toast.error("Fetch failed");

      setLoading(false);
    }
  };

  useEffect(() => {
    getCertificates();
  }, []);

  // 🔹 Update Position
  const updatePosition = async (id) => {
    try {

      await axios.put(
        `http://localhost:3232/api/v1/certificates/position/${id}`,
        {
          position: positions[id],
        }
      );

      toast.success("Position updated");

      getCertificates();

    } catch (err) {

      console.log(err);

      toast.error(
        err?.response?.data?.message || "Update failed"
      );
    }
  };

  // 🔹 Delete
  const deleteHandler = async (id) => {

    const confirm = window.confirm(
      "Delete this image?"
    );

    if (!confirm) return;

    try {

      await axios.delete(
        `http://localhost:3232/api/v1/certificates/${id}`
      );

      toast.success("Deleted successfully");

      getCertificates();

    } catch (err) {

      console.log(err);

      toast.error("Delete failed");
    }
  };

  return (
    <div className="page-wrapper">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">

            {/* 🔥 Upload Form */}
            <div className="card mb-4">
              <div className="card-body">

                <form onSubmit={btnHandler}>

                  <div className="form-group">
                    <label>
                      Upload Certificates (Multiple)
                    </label>

                    <input
                      type="file"
                      className="form-control"
                      multiple
                      accept="image/*"
                      onChange={imgHandler}
                    />
                  </div>

                  <div className="form-group mt-3">
                    <input
                      type="submit"
                      value="Upload"
                      className="btn btn-primary"
                    />
                  </div>

                </form>

              </div>
            </div>

            {/* 🔥 List Table */}
            <div className="card">
              <div className="card-body">

                <div className="table-responsive">

                  <table className="table table-bordered shadow-sm">

                    <thead>
                      <tr>
                        <th>S.No.</th>
                        <th>Mobile Image</th>
                        <th>Desktop Image</th>
                        <th>Position</th>
                        <th>Action</th>
                      </tr>
                    </thead>

                    <tbody>

                      {loading && (
                        <tr>
                          <td colSpan="5">
                            <Skeleton count={3} />
                          </td>
                        </tr>
                      )}

                      {data.length > 0 ? (

                        data.map((item, index) => (

                          <tr key={item.id}>

                            <td>{index + 1}</td>

                            <td>
                              <img
                                src={item.mobile_image}
                                alt=""
                                style={{
                                  height: "60px",
                                  borderRadius: "8px",
                                }}
                              />
                            </td>

                            <td>
                              <img
                                src={item.desktop_image}
                                alt=""
                                style={{
                                  height: "60px",
                                  borderRadius: "8px",
                                }}
                              />
                            </td>

                            {/* 🔥 Position */}
                            <td>
                              <div className="d-flex gap-2 align-items-center">

                                <input
                                  type="number"
                                  className="form-control"
                                  style={{ width: "90px" }}
                                  value={positions[item.id] ?? ""}
                                  onChange={(e) =>
                                    setPositions({
                                      ...positions,
                                      [item.id]: e.target.value,
                                    })
                                  }
                                />

                                <button
                                  className="btn btn-sm btn-primary"
                                  onClick={() =>
                                    updatePosition(item.id)
                                  }
                                >
                                  Update
                                </button>

                              </div>
                            </td>

                            {/* 🔥 Delete */}
                            <td>

                              <MdDelete
                                size={24}
                                style={{
                                  color: "red",
                                  cursor: "pointer",
                                }}
                                onClick={() =>
                                  deleteHandler(item.id)
                                }
                              />

                            </td>

                          </tr>
                        ))

                      ) : (

                        !loading && (
                          <tr>
                            <td
                              colSpan="5"
                              className="text-center text-danger"
                            >
                              No data found
                            </td>
                          </tr>
                        )

                      )}

                    </tbody>

                  </table>

                </div>

              </div>
            </div>

          </div>
        </div>
      </div>

      <ToastContainer />
    </div>
  );
};

export default Certificates;